import { render, staticRenderFns } from "./ServicesReservationAddedServices.vue?vue&type=template&id=334b1f30&"
import script from "./ServicesReservationAddedServices.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports